<script setup>
import {onBeforeMount, reactive} from 'vue'
import {icons} from '@/paks/vu-theme'

const props = defineProps({
    icon: String,
})

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    icon: null,
    icons: [],
})

onBeforeMount(() => {
    page.icons = Object.keys(icons)
        .map((i) => `$${i}`)
        .sort()
    page.icon = props.icon
})

function onInput(v) {
    emit('update:modelValue', v)
}
</script>

<template>
    <v-combobox
        class="vu-input vcol vcol-12"
        v-model="page.icon"
        bg-color=""
        clearable
        density="compact"
        variant="underlined"
        label="Icon"
        placeholder="Enter icon name"
        :items="page.icons"
        :color="undefined"
        @update:modelValue="onInput">
        <template v-slot:item="{item, props}">
            <v-list-item v-bind="props">
                <template v-slot:prepend>
                    <v-icon size="medium" color="info" :icon="item.raw"></v-icon>
                </template>
            </v-list-item>
        </template>
        <template v-slot:selection="{item}">
            <div>
                <v-icon size="medium" _color="info" :icon="item.title"></v-icon>
                <span class="ml-2">{{ item.title }}</span>
            </div>
        </template>
    </v-combobox>
</template>

<style lang="scss">
</style>
